// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  emulator: false,
  firebase: {
    apiKey: 'AIzaSyAXqLjO71v_l92AzJBlv0faJLsjh1eaCXg',
    authDomain: 'auth.infans.be',
    databaseURL: 'https://infans.europe-west1.firebasedatabase.app',
    projectId: 'infanscorp',
    storageBucket: 'infanscorp.appspot.com',
    messagingSenderId: '629220135401',
    appId: '1:629220135401:web:058e86713e7f2e8b'
  },
  stripe: {
    publishable_key: 'pk_test_Ag7Zt4wNrHmWw0ptgZDwCjhA006EG4TCcx'
  },
  calendar: {
    i18n: {
      months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
      monthsShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
      weekdays: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
      weekdaysShort: ['zon', 'maa', 'din', 'woe', 'don', 'vrij', 'zat'],
      weekdaysAbbrev: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za']
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
